
          <template>
  <v-card color="rgba(255,255,255,0.01)">
  <div class="moving-clouds" 
    :style="{ backgroundImage: 'url(' + require('@/assets/clouds3.png') + ')' }"></div>
  <v-bottom-sheet v-model="helpsheet">
      <v-sheet class="text-center" height="200px">
        <v-btn
          class="mt-6"
          dark
          color="red"
          @click="helpsheet = !helpsheet"
        >close</v-btn>
        <div>This is the My Profile help sheet. What would you want to know?</div>
      </v-sheet>
    </v-bottom-sheet>
  <v-banner two-line :sticky="true" class="topbasicoutlined" v-if="!EditingUser" height="80px">
  <v-container fluid>
     <v-card width ="100%" flat>
           <v-btn @click="ToggleHelp()" color="red" dark
                fab
                small
                absolute
                top
                right><v-icon>mdi-help</v-icon></v-btn>
                <v-btn @click="EditUser()" color="#012840" dark
                fab
                small
                absolute
                bottom
                right><v-icon>mdi-pencil</v-icon></v-btn>
          <v-layout row class="secondary white--text justify-center">
      <h2 class="headline white--text font-weight-light">My Profile</h2>
    </v-layout>
      </v-card>
    </v-container>
  </v-banner>

  <v-banner two-line :sticky="true" class="topbasicoutlined" v-if="EditingUser" height="80px">
   <v-container fluid>
   <v-card width ="100%" flat>
   <v-layout row class="secondary white--text justify-center ">
      <h2 class="headline white--text font-weight-light">My Profile</h2>
    </v-layout>
     <v-btn @click="CancelUserEditing()" color="red" dark
                fab
                small
                top
                left><v-icon>mdi-cancel</v-icon></v-btn>
                <v-btn @click="UpdateUser()" color="#012840" dark
                fab
                small
                absolute
                bottom
                right><v-icon>mdi-content-save</v-icon></v-btn>
      </v-card>
    </v-container>
  </v-banner>
  <v-layout class="justify-center">
     <v-flex lg8 md10>
        
       <v-layout row v-if="!EditingUser">
         
          
        <v-col class="topspace">
           <v-card flat class="transparent" height="75">
            </v-card>
          <v-card dark flat width="90%" class="mx-4 secondary text-xs-center elevatedsectionheader">     
            <v-card-title class="align-center">
              Edit Profile
            </v-card-title>
            <v-card-subtitle >
             Complete Profile
            </v-card-subtitle>             
              </v-card>
        
          <v-card outlined class="overlayed mx-3" height="100%">
            <v-card flat height="60">
            </v-card>
              <v-card flat class="mx-3">
                <v-card-subtitle class="mx-2 my-2">
                  <v-layout row>
                    <h3 class="primary--text">Surname</h3><v-spacer></v-spacer><p>{{ Surname }}</p>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle class="mx-2 my-2">
                  <v-layout row>
                    <h3 class="primary--text">Name</h3><v-spacer></v-spacer><p>{{ Name }}</p>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle class="mx-2 my-2">
                  <v-layout row>
                    <h3 class="primary--text">Business Unit</h3><v-spacer></v-spacer><a :href="'/BusinessUnit/'+BusinessUnit.id" target="_blank" v-if="BusinessUnit"><p>{{ BusinessUnit.Name }}</p></a><p v-if="!BusinessUnit"></p>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle class="mx-2 my-2">
                  <v-layout row>
                    <h3 class="primary--text">Manager</h3><v-spacer></v-spacer><a :href="'/User/'+Manager.id" target="_blank" v-if="Manager"><p>{{ Manager.Full_Name }}</p></a><p v-if="!Manager"></p>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle class="mx-2 my-2">
                  <v-layout row>
                    <h3 class="primary--text">Activity Manager</h3><v-spacer></v-spacer><v-switch @change="UpdateUserTaskManager()" label="User Manages others" v-model="IsTeamActivityManager"></v-switch>
                  </v-layout>
                  </v-card-subtitle>
                    <v-card-subtitle class="mx-2 my-2">
                  <v-layout row>
                    <h3 class="primary--text">Notification Emails</h3><v-spacer></v-spacer><v-switch @change="UpdateNotifiationEmailer()" label="All Notifications get Emailed" v-model="UsersWantsEmailsOnAllNotifications"></v-switch>
                  </v-layout>
                  </v-card-subtitle>
                </v-card>
            </v-card>
        </v-col>
        <v-col cols="12" md="4" class="justify-center">
           
          <v-layout class="justify-center">
          
           <v-avatar
              color="grey"
              size="164" 
              class="elevatedsectionheader"                     
            >
            <v-img :src="ProfilePhoto"><v-btn v-if="!selectedprofilephotoFile" @click="$refs.profilephotofileInputer.click()" color="white" dark icon absolute top right><v-icon>mdi-pencil</v-icon></v-btn></v-img>
          </v-avatar>
       
          </v-layout>
          
          <v-layout class="justify-center overlayed borderthicknobottom mx-3">
          <v-card tile flat height="100px" width="100%">
          </v-card>
          </v-layout>
          <v-layout class="justify-center borderthicknotop mx-3">
         
            <v-card tile flat  width="100%"  class="text-xs-center">
              <h6 class="subheader centertext">MARKETING MANAGER</h6>
              <h4 class="headline font-weight-thin black--text centertext my-1">{{UserData.Full_Name}}</h4>
              <p class="centertext grey--text my-2">
                Don't be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
              </p>
              <v-expansion-panels dark>
            <v-expansion-panel class="primary">
              <v-expansion-panel-header>Security
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-combobox v-model="AssignedRoles" :items="SecurityRoles" item-text="DisplayName" @change="AssignRoles()" label="Assign Security Roles (Multiple Allowed)" multiple></v-combobox>
                  <v-list light>
                    <v-list-item class="newbasicoutlined">
                      <v-list-item-content>
                    <h4 class="outlinefont">System Security Roles</h4>
                    </v-list-item-content>
                    <v-spacer></v-spacer>
                    <v-list-item-content>
                      </v-list-item-content>
                      </v-list-item>
                    <v-list-item v-for="role in SecurityRoles" :key="role.itemObjKey">
                      <v-list-item-content>
                        {{  role.DisplayName }}
                        </v-list-item-content>
                        <v-list-item-content>
                        {{  role.Description }}
                        </v-list-item-content>
                         <v-list-item-content>
                        <v-icon @click="ActivateSecurityRoleEditdialog(role)">mdi-eye</v-icon>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
         
              </v-card>
         
            
          
          </v-layout>
          
          </v-col>
       </v-layout>
     </v-flex>
  </v-layout>
  <v-layout class="justify-center">
     <v-flex lg8 md10>

          
<v-layout row v-if="EditingUser" class="outline">
          <h3 class="primary--text">Tab 1</h3><br><br>
          <v-row>
        <v-col><br>
          <v-card flat>
              <v-card flat>
                <v-card-subtitle>
                  <v-layout row>
                    <v-col>
                      <v-row>
                  <div><h4>FullName</h4><v-text-field v-model="FullName"></v-text-field></div>
                        </v-row>
                    </v-col>
                  <v-col>
                  </v-col>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle>
                  <v-layout row>
                    <v-col>
                      <v-row>
                  <div><h4>Profile Photo</h4>
                  <img :src="ProfilePhoto" height="150px"></div>
                        </v-row>
                    </v-col>
                  <v-col>
                  </v-col>
                  </v-layout>
                  </v-card-subtitle>
                </v-card>
            </v-card>
          </v-col>
        <v-col><br>
          <v-card flat>
              <v-card flat>
                <v-card-subtitle>
                  <v-layout row>
                    <v-col>
                      <v-row>
                  <div><h4>Surname</h4><v-text-field v-model="Surname"></v-text-field></div>
                        </v-row>
                    </v-col>
                  <v-col>
                  </v-col>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle>
                  <v-layout row>
                    <v-col>
                      <v-row>
                  <div><h4>Name</h4><v-text-field v-model="Name"></v-text-field></div>
                        </v-row>
                    </v-col>
                  <v-col>
                  </v-col>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle>
                  <v-layout row>
                    <v-col>
                      <v-row>
                  <div><h4>Business Unit</h4><v-combobox
                        v-model="BusinessUnit"


                        :items="BusinessUnitArray"

                        item-text="Name"
                        hide-selected
                        label="Business Unit"
                        small-chips
                        solo
                        flat
                        ></v-combobox></div>
                        </v-row>
                    </v-col>
                  <v-col>
                  </v-col>
                  </v-layout>
                  </v-card-subtitle>
                <v-card-subtitle>
                  <v-layout row>
                    <v-col>
                      <v-row>
                  <div><h4>Manager</h4><v-combobox
                        v-model="Manager"


                        :items="ManagerArray"
                        @change="AssignUsersHierarchy()"
                        item-text="Full_Name"
                        hide-selected
                        label="Manager"
                        small-chips
                        solo
                        flat
                        ></v-combobox></div>
                        </v-row>
                    </v-col>
                  <v-col>
                  </v-col>
                  </v-layout>
                  </v-card-subtitle>
                </v-card>
            </v-card>
          </v-col>
          </v-row>
          </v-layout>

<v-dialog v-model="SecurityRoledialog" fullscreen>
    <v-card width="100%" height="100%">
      <v-app>
        <v-layout row class="justify-center">
          <v-container bg fill-height grid-list-md text-xs-center>
            <v-layout row wrap align-center>
              <v-flex>
                <h4>Configure the Role</h4><br>
                <v-text-field label="Name" v-model="editedRole.DisplayName"></v-text-field>
                <v-textarea label="Description" v-model="editedRole.Description"></v-textarea>
                <v-btn text @click="closeSecurityRoleDialog()">Close</v-btn>
                <v-list dense>
               <v-list-item>
                 <v-list-item-content>
                   <strong>DataSet</strong>
                   </v-list-item-content>
                 <v-list-item-content>
                   <strong>Get</strong>
                   </v-list-item-content>
                   <v-list-item-content>
                   <strong>List</strong>
                   </v-list-item-content>
                   <v-list-item-content>
                   <strong>Create</strong>
                   </v-list-item-content>
                   <v-list-item-content>
                   <strong>Update</strong>
                   </v-list-item-content>
                   <v-list-item-content>
                   <strong>Delete</strong>
                   </v-list-item-content>
                 </v-list-item>
                 <v-list-item v-for="build in editedRole.Builds" :key="build.id">
                   <v-list-item-content>
                      {{ build.tempname }}
                     </v-list-item-content>
                     <v-list-item-content>
                      <v-checkbox readonly v-model="build.getBoolean"></v-checkbox>
                      <v-select readonly v-model="build.getUnitConfig" :items="['All','UnitDown','UserUnit','Owner']"></v-select>
                     </v-list-item-content>
                     <v-list-item-content>
                      <v-checkbox readonly v-model="build.listBoolean"></v-checkbox>
                      <v-select readonly v-model="build.listUnitConfig" :items="['All','UnitDown','UserUnit','Owner']"></v-select>
                     </v-list-item-content>
                     <v-list-item-content>
                      <v-checkbox readonly v-model="build.createBoolean"></v-checkbox>
                      <v-select readonly v-model="build.createUnitConfig" :items="['All','UnitDown','UserUnit','Owner']"></v-select>
                     </v-list-item-content>
                     <v-list-item-content>
                      <v-checkbox readonly v-model="build.updateBoolean"></v-checkbox>
                      <v-select readonly v-model="build.updateUnitConfig" :items="['All','UnitDown','UserUnit','Owner']"></v-select>
                     </v-list-item-content>
                     <v-list-item-content>
                      <v-checkbox readonly v-model="build.deleteBoolean"></v-checkbox>
                      <v-select readonly v-model="build.deleteUnitConfig" :items="['All','UnitDown','UserUnit','Owner']"></v-select>
                     </v-list-item-content>
                   </v-list-item>
               </v-list>
              </v-flex>

            </v-layout>

          </v-container>
          </v-layout>
      </v-app>
      </v-card>
    </v-dialog>
      <v-tabs row>
      </v-tabs>
      </v-flex>
  </v-layout>

   <v-layout class="justify-center">
     <v-flex lg8 md10>
    
        
      <v-tabs row>
      </v-tabs>
      </v-flex>
  </v-layout>
     <v-layout column class="fab-container" id="myBtn">
    <v-btn fab @click="topFunction()" dark color="red">
      <v-icon>mdi-arrow-up</v-icon>
    </v-btn>
  </v-layout>
  </v-card>
</template>




<script>
import firebase from 'firebase';
import db from '@/main'
import format from 'date-fns/format'

export default {
  middleware: 'auth',
components: {
},
  data() {
    return {
      rules: {
          min8Chars: value => value.length >= 8 || "Min. 8 characters",
          required: value => !!value || "Required.",
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || "Invalid e-mail.";
          }
        },
      ActivitiesArray: [],
      NotesArray: [],
      TaskFilterDate: '',
      TaskDialog: false,
      NewTask: {
            Name: '',
            description: '',
            activitytype: 'Task',
            regardingtype: 'User',
            createdon: format(new Date(),'yyyy-MM-dd'),
            duedate: '',
            Owner: {id: '', Name: '', Surname: '', Full_Name: ''},
            Ownerid: '',
            creatorfullname: '',
            creatorid: ''
      },
      DefaultNewTask: {
            Name: '',
            description: '',
            activitytype: 'Task',
            regardingtype: 'User',
            createdon: format(new Date(),'yyyy-MM-dd'),
            duedate: '',
            Owner: {id: '', Name: '', Surname: '', Full_Name: ''},
            Ownerid: '',
            creatorfullname: '',
            creatorid: ''
      },
      pickerDate: null,
      TaskStatusFilter: 'Open',
      CreatedOnmenu: false,
      DueDatemenu: false,
      FullName:  '',
      
      
      
      
      EditingUser: false,
      dialog: false,
      initialize: '',
      search: '',
      UserData: {},
      headers: [
      
        { text: 'Actions', value: 'action', sortable: false },
      ],
      FullName:  '',
      Name:  '',
      Surname:  '',
      BusinessUnit:  {id: '', Name: ''},
      Manager:  {id: '', Full_Name: ''},
      ProfilePhoto:  '',
      Managerfullname: null,
      profilephotofilesnackbar: false,
      selectedprofilephotoFile: '',
      profilephotolocalURL: '',
      BusinessUnitArray: [],
      BusinessUnitfilter: {Name: ''},ManagerArray: [],
      Managerfilter: {Full_Name: ''},
      EditingUser: false,
      dialog: false,
      initialize: '',
      search: '',
      helpsheet: false,
      headers: [
        
        { text: 'FullName', value: 'Full_Name'},
        { text: 'Name', value: 'Name'},
        { text: 'Surname', value: 'Surname'},
        { text: 'Business Unit', value: 'Business_Unit.Name'},
        { text: 'Manager', value: 'Manager.Full_Name'},
        { text: 'Actions', value: 'action', sortable: false },
      ],
      Buildsbysystem: [
        {
          id: "02y7N2yNELwRryTuv8p7",
          tempname: "User"
        },
        
        {
          id: "0zo5rPBdtqHTDgJagAsB",
          tempname: "Account"
        },
        
        {
          id: "V8X6lZHMZLxAlqUwXF6Y",
          tempname: "Business Unit"
        },
        ],
      AssignedRoles: [],
      SecurityRoles: [
      {
        Builds: [
          {
          createBoolean: true,
          createUnitConfig: "All",
          deleteBoolean: true,
          deleteUnitConfig: "All",
          getBoolean: true,
          getUnitConfig: "All",
          id: "02y7N2yNELwRryTuv8p7",
          listBoolean: true,
          listUnitConfig: "All",
          tempname: "User",
          updateBoolean: true,
          updateUnitConfig: "All"
          },
        
          {
          createBoolean: true,
          createUnitConfig: "All",
          deleteBoolean: true,
          deleteUnitConfig: "All",
          getBoolean: true,
          getUnitConfig: "All",
          id: "0zo5rPBdtqHTDgJagAsB",
          listBoolean: true,
          listUnitConfig: "All",
          tempname: "Account",
          updateBoolean: true,
          updateUnitConfig: "All"
          },
        
          {
          createBoolean: true,
          createUnitConfig: "All",
          deleteBoolean: true,
          deleteUnitConfig: "All",
          getBoolean: true,
          getUnitConfig: "All",
          id: "V8X6lZHMZLxAlqUwXF6Y",
          listBoolean: true,
          listUnitConfig: "All",
          tempname: "Business Unit",
          updateBoolean: true,
          updateUnitConfig: "All"
          },
        
        ],
        Description: "Add more details about this new security role here",
        DisplayName: "System Admin",
        Name: "Name 1"
          },
      {
        Builds: [
          {
          createBoolean: true,
          createUnitConfig: "All",
          deleteBoolean: false,
          deleteUnitConfig: "",
          getBoolean: true,
          getUnitConfig: "All",
          id: "02y7N2yNELwRryTuv8p7",
          listBoolean: true,
          listUnitConfig: "All",
          tempname: "User",
          updateBoolean: true,
          updateUnitConfig: "All"
          },
        
          {
          createBoolean: true,
          createUnitConfig: "UnitDown",
          deleteBoolean: false,
          deleteUnitConfig: "",
          getBoolean: true,
          getUnitConfig: "UnitDown",
          id: "0zo5rPBdtqHTDgJagAsB",
          listBoolean: true,
          listUnitConfig: "UnitDown",
          tempname: "Account",
          updateBoolean: true,
          updateUnitConfig: "UnitDown"
          },
        
          {
          createBoolean: true,
          createUnitConfig: "All",
          deleteBoolean: false,
          deleteUnitConfig: "",
          getBoolean: true,
          getUnitConfig: "All",
          id: "V8X6lZHMZLxAlqUwXF6Y",
          listBoolean: true,
          listUnitConfig: "All",
          tempname: "Business Unit",
          updateBoolean: true,
          updateUnitConfig: "All"
          },
        
        ],
        Description: "Add more details about this new security role here",
        DisplayName: "Sales Representative",
        Name: "Name 2"
          },],
      SecurityRoleIndex: -1,
      SecurityRoledialog: false,
      editedRole: {Name: '', DisplayName: '', Description: '', Builds: []},
      defaultRole: {Name: '', DisplayName: '',Description: '', Builds: []},
      RolesArray: [],
      snackbar: false,
      EditedUsersnackbar: false,
      UserEditdialog: false,
      newUserdialog: false,
      UsersArray: [],
      editedIndex: -1,
      defaultItem: {
        id: '',
      },
      editedItem: {
        id: '',
      },
      IsTeamActivityManager: false,
      UsersWantsEmailsOnAllNotifications: true,
      UsersArray:[],
      BusinessUnitsArray: [],
      Owner: {Name: '', Surname: '', id: '', Full_Name: ''},
      Manager: {Name: '', Surname: '', id: '', Full_Name: ''},
      BusinessUnit: {},
      Name:  '',
      Description:  '',
      Parent:  {id: '', Name: ''},
      Parentname: null,
      ParentArray: [],
      Parentfilter: {Name: ''},
      EditingBusinessUnit: false,
      ParentsToUpdate: [],
      ManagersToUpdate: [],
      SubordindatesArray: [],
      ChildArrayQuery: [],
      UserRecord: {},
      UserBusinessUnitID: '',
      UserRoles: '',
      UserBusUnitChildren: [],
      UserBusUnitParents: [],
      getAll: false,
      getUnitDown: false,
      getUserUnit: false,
      getOwner: false,
      listAll: false,
      listUnitDown: false,
      listUserUnit: false,
      listOwner: false,
      createAll: false,
      createUnitDown: false,
      createUserUnit: false,
      createOwner: false,
      updateAll: false,
      updateUnitDown: false,
      updateUserUnit: false,
      updateOwner: false,
      deleteAll: false,
      deleteUnitDown: false,
      deleteUserUnit: false,
      deleteOwner: false,
      AllgetRoles: [
  "System Admin",
  "Sales Representative"
],
      UnitDowngetRoles: [],
      UserUnitgetRoles: [],
      OwnergetRoles: [],
      AlllistRoles: [
  "System Admin",
  "Sales Representative"
],
      UnitDownlistRoles: [],
      UserUnitlistRoles: [],
      OwnerlistRoles: [],
      AllcreateRoles: [
  "System Admin",
  "Sales Representative"
],
      UnitDowncreateRoles: [],
      UserUnitcreateRoles: [],
      OwnercreateRoles: [],
      AllupdateRoles: [
  "System Admin",
  "Sales Representative"
],
      UnitDownupdateRoles: [],
      UserUnitupdateRoles: [],
      OwnerupdateRoles: [],
      AlldeleteRoles: [
  "System Admin"
],
      UnitDowndeleteRoles: [],
      UserUnitdeleteRoles: [],
      OwnerdeleteRoles: [],
      helpsheet: false,
      UndefinedMandatoryFields: [],
      RelatedObj: {}
    }
  },

  created(){
    
    this.GetUsersManager()
    this.GetRequestingUser()
    this.GetUsers()
    window.addEventListener('scroll', this.handleScroll)

  },
  computed: { 
    ActivitiesSearched() {
      return this.ActivitiesArray.filter(Activity => {
        if(Activity.Name){return Activity.Name.toLowerCase().includes(this.search.toLowerCase())}}).filter(Activity => {if(Activity.description){return Activity.description.toLowerCase().includes(this.search.toLowerCase())}
      })
      },
      ActivitiesFilteredandSearched() {
      return this.ActivitiesSearched.filter(Activity => {if(this.ActivityTypefilter){if(Activity.activitytype){ return Activity.activitytype.includes(this.ActivityTypefilter)}} else {return Activity}}).filter(Activity => {if(this.RegardingTypefilter){if(Activity.regardingtype){ return Activity.regardingtype.includes(this.RegardingTypefilter)}} else {return Activity}})
      },
      TasksFilteredandSearched(){
          return this.ActivitiesFilteredandSearched.filter(activity => {
              return activity.activitytype === 'Task' && activity.duedate.includes(this.pickerDate) && activity.status.includes(this.TaskStatusFilter)
          })
      },
      TasksFilteredandSearchedTable(){
          return this.TasksFilteredandSearched.filter(activity => {
              return activity.duedate === this.TaskFilterDate
          })
      },
        PotentialManagers() {
      return this.UsersArray.filter(unit => {
        return !this.SubordindatesArray.includes(unit.id)
      })
    },
   
    },
  methods: {
    AddNote(){
      let NewNote = {
        Title: 'New Note',
        Owner: {Full_Name: this.UserRecord.Full_Name, id:this.UserRecord.id},
        Description: 'Add Description to the Note',
        Color: '#ECEC93FF',
        TitleColor: '#EBEB6C',
        Dark: false
      }
      this.NotesArray.push(NewNote)
      this.UpdateNotesArray()
    },
    LightenColor(note) {
    let color = note.Color
    let num = parseInt(color.replace("#",""), 16)
    let amt = Math.round(2.55 * 25)
    let R = (num >> 16) - amt
    let B = (num >> 8 & 0x00FF) - amt
    let G = (num & 0x0000FF) - amt;

    note.TitleColor = (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
    },
    ToggleNoteDark(note){
      if(note.Dark === true){
        note.Dark = false
        this.UpdateNotesArray()
      }
      else{
        note.Dark = true
        this.UpdateNotesArray()
      }
    },
    UpdateNotesArray(){
      db.collection('users').doc(this.UserRecord.id).update({
        notesarray: this.NotesArray
      })
    },
    DateFormatter(date){
      let yearstring = date.split('-')[0]
        let monthstring = date.split('-')[1]
        let daystring = date.split('-')[2]
        let yearnumber = Number(yearstring)
        let monthnumber = Number(monthstring)
        let daynumber = Number(daystring)
        return new Date(yearnumber, monthnumber-1, daynumber)
    },
    SaveNewTask(){
      const TasktoAdd = {
            Name: this.NewTask.Name,
            description: this.NewTask.description,
            activitytype: 'Task',
            regardingtype: 'User',
            createdon: format(new Date(),'yyyy-MM-dd'),
            duedate: this.DateFormatter(this.NewTask.duedate),
            Owner: {id: this.NewTask.Owner.id, Name: this.NewTask.Owner.Name, Surname: this.NewTask.Owner.Surname, Full_Name: this.NewTask.Owner.Full_Name},
            Ownerid: this.NewTask.Owner.id,
            creatorfullname: this.UserRecord.Full_Name,
            creatorid: this.UserRecord.id,
            status: 'Open',
            regardingrecord: {
              Link:'/Account/'+this.UserRecord.id, Name:this.CompanyName, companyname:this.CompanyName,id: this.UserRecord.id
            },

            FollowingUsers: [{id: this.NewTask.Owner.id, Name: this.NewTask.Owner.Name, Surname: this.NewTask.Owner.Surname, Full_Name: this.NewTask.Owner.Full_Name},{id: this.UserRecord.id, Name: this.UserRecord.Name, Surname: this.UserRecord.Surname, Full_Name: this.UserRecord.Full_Name}]
      }
      if(typeof this.BusinessUnit.id !== 'undefined'){
        TasktoAdd.Business_Unitid = this.BusinessUnit.id
      }
      db.collection('activities').add(TasktoAdd).then(doc => {

             if(this.NewTask.activitytype === 'Task'){
            const NewNotification = {
              taskid: doc.id,
              Type: 'Task Created',
              Header: 'New Task -'+TasktoAdd.Name,
              Content: TasktoAdd.description,
              CreatorFullName: TasktoAdd.creatorfullname,
              CreatorID: TasktoAdd.creatorid,
              Owner: TasktoAdd.OwnerOwner,
              Ownerid: TasktoAdd.Ownerid,
              Read: false,
              Path: '/Activity/',
              Message: 'a New Task has been assigned to you by '+TasktoAdd.creatorfullname,
                    Date: new Date()
            }
            db.collection('notifications').add(NewNotification).then(notedoc => {
            let tempPath = '/Activity/'+doc.id
            db.collection('notifications').doc(notedoc.id).update({
              Path: tempPath
            })
            })
             }


          this.CloseTaskDialog()
          })
    },

    CloseTaskDialog(){
      this.NewTask = Object.assign({},this.DefaultNewTask)
      this.TaskDialog = false
    },

    GetActivities( regardingquery) {

      regardingquery.get().then(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.ActivitiesArray.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }


      })
    })
  },
    AssignUsersHierarchy(){
      console.log('the first call')
      console.log(this.Manager)
      let CurrentUnitObj = this.ManagerArray.find(obj => obj.id == this.UserRecord.id)
      let CurrentUnitIndex = this.ManagerArray.indexOf(CurrentUnitObj)
      this.ManagerArray[CurrentUnitIndex].Manager = {Name: this.Manager.Name, id: this.Manager.id}
      this.ManagerArray[CurrentUnitIndex].Managerid = this.Manager.id
      // this.UpdateBusinessUnit()
      this.fixunithierarchy()
    },

    async fixunithierarchy(){
      console.log('I await')

      await this.DestroyOldHierarchy()
      console.log('Done Waiting')

      this.getParentofParent(this.Manager)
    },


    async DestroyOldHierarchy(){

      console.log('watch this')
      console.log(this.PotentialManagers)
      let FilteredUsersArray = this.PotentialManagers.filter(unit => {
        return unit.id !== this.UserRecord.id
      })
      let CurrentUser = this.UsersArray.find(obj => obj.id === this.UserRecord.id)
          console.log('current bu')
          console.log(CurrentUser)

      Array.from(Array(CurrentUser.Subordinatearrayquery.length).keys()).map(x => {
        this.RemoveBUfromParentQueryandDBArray(CurrentUser.Subordinatearrayquery[x])
      })
    },

    RemoveBUfromParentQueryandDBArray(BUid){
      console.log("removing "+BUid)
      // let CurrentUser = this.UsersArray.find(obj => obj.id === this.UserRecord.id)
      // let BUidCheck = CurrentUser.Subordinatearrayquery.indexOf(BUid)
      // if(BUidCheck === -1){
      let BUtoRemove = this.UsersArray.find(obj => obj.id == BUid)
      let FilteredUsersArray = this.PotentialManagers.filter(unit => {return unit.id !== BUid && unit.id !== this.UserRecord.id && unit.id !== BUtoRemove.Managerid && unit.Managerid !== this.UserRecord.id})
      console.log('filterarray')
      console.log(FilteredUsersArray)
      FilteredUsersArray.map(unit => {
        if(BUtoRemove.Managerid !== unit.id){
          let dbchildindex = unit.Subordinatearrayquery.indexOf(BUid)
          let querychildobjectprop = unit.SubordinateArrayDBrules[BUid]

          if(dbchildindex !== -1){
            console.log('BUtoRemove '+BUtoRemove.id+' is index '+dbchildindex+' on '+unit.id)
            unit.Subordinatearrayquery.splice(dbchildindex,1)

            }
            console.log('BUtoRemove '+BUtoRemove.id+' has no index on '+unit.id)
            if(typeof querychildobjectprop !== 'undefined'){
              console.log('from '+unit.id)
            delete unit.SubordinateArrayDBrules[BUid]
            db.collection('users').doc(unit.id).update({
            SubordinateArrayDBrules: unit.SubordinateArrayDBrules,
            Subordinatearrayquery: unit.Subordinatearrayquery
              })
            }
        }
        else {
          console.log('BU '+BUid+' has '+ unit.id+' as a parent')
        }
        })


        if(this.Manager.Name !== ''){
            this.ManagersToUpdate = []
            console.log('initial call for')
            console.log(this.Manager)
            console.log('Finished')
            console.log('parentarrayvs filtered')
            console.log(this.UsersArray)
            console.log(FilteredUsersArray)
          }
          // }
    },

    UpdateParent(parent){
      console.log('now calling UpdateParent')
        let FilteredUsersArray = this.PotentialManagers.filter(unit => {return unit.id !== this.UserRecord.id})
        let unitdata = FilteredUsersArray.find(obj => obj.id == parent.id)

          if(typeof unitdata.Manager !== 'undefined'){
          console.log('this parent has a parent')
          console.log(unitdata)
          this.getParentofParent(unitdata.Manager)
          }
          else {
          console.log('second okay save it')
          console.log(this.ManagersToUpdate)
          this.ManagerArrayUpdate()
          }


    },

    ManagerArrayUpdate() {
      console.log('now calling ManagerArrayUpdate')
      Array.from(Array(this.ManagersToUpdate.length).keys()).map(x => {
        this.PrepareChildrenList(this.ManagersToUpdate[x])
      })
    },

    PrepareChildrenList(parent){
      console.log('now calling PrepareChildrenList')
      let EditedUnit = this.UsersArray.find(obj => obj.id == this.UserRecord.id)
      // this.AddQueryandDBChildtoParent(EditedUnit.id)
      console.log("parent")
      console.log(parent)
      let unitdata = this.UsersArray.find(obj => obj.id == parent)
      console.log("unitdata")
      console.log(unitdata)
        Array.from(Array(unitdata.Subordinatearrayquery.length).keys()).map(x => {
        this.AddQueryandDBChildtoParent(EditedUnit.Subordinatearrayquery[x],parent)
      })
    },

    AddQueryandDBChildtoParent(length, parent){
      console.log('now calling AddQueryandDBChildtoParent')
      console.log(length)
      let CurrentUser = this.UsersArray.find(obj => obj.id === this.UserRecord.id)
      console.log('each individually')
      console.log('parents first')
      console.log(parent)
        let FilteredUsersArray = this.PotentialManagers.filter(unit => {return unit.id !== this.UserRecord.id})
        let unitdata = this.UsersArray.find(obj => obj.id == parent)
      console.log(unitdata)
      Array.from(Array(CurrentUser.Subordinatearrayquery.length).keys()).map(x => {
        this.NarrowChildofChildQueryandDBtoParent(CurrentUser.Subordinatearrayquery[x], unitdata)
      })
      // this.NarrowChildofChildQueryandDBtoParent(unitdata, CurrentUser)
    },

    NarrowChildofChildQueryandDBtoParent(unitid,unitdata){
      console.log('now calling NarrowChildofChildQueryandDBtoParent')
      let checkon = unitdata.Subordinatearrayquery.indexOf(unitid)
      if(checkon === -1){
        console.log('not on array')
        console.log(unitid)
      unitdata.Subordinatearrayquery.push(unitid)
      console.log('new array')
      console.log(unitdata.Subordinatearrayquery)
      }
      else {
        console.log()
        console.log('is on array')
      }
      let tempchildarrayQuery = unitdata.Subordinatearrayquery
      console.log(unitdata)
      unitdata.SubordinateArrayDBrules[unitid] = true
      let tempchildarrayDBRules = unitdata.SubordinateArrayDBrules
      db.collection('users').doc(unitdata.id).update({
        Subordinatearrayquery: tempchildarrayQuery,
        SubordinateArrayDBrules: tempchildarrayDBRules,
      })
      // this.UpdateBusinessUnit()
    },


    getParentofParent(parent){
      console.log('now calling getParentofParent')
      console.log(parent)
      this.ManagersToUpdate.push(parent.id)
      let unitdata = this.UsersArray.find(obj => obj.id == parent.id)

        if(typeof unitdata.Manager === 'undefined'){
          console.log('has no parent')
        this.UpdateParent(unitdata)
        }
        else{
          console.log('yip has parent')
          this.ManagersToUpdate.push(unitdata.Manager.id)
          this.UpdateParent(unitdata.Manager)
        }

    },
    handleScroll(event) {
      var mybutton = document.getElementById("myBtn");
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
      }
      else {
        mybutton.style.display = "none";
      }
    },

    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    ToggleHelp(){
    this.helpsheet = true
    },
    
      GetUsers(){
      db.collection('users').onSnapshot(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.UsersArray.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }


      })
    })
    },
    ResetFilters() {},
    
    ResetSearch() {
      this.search = ''
    },
    CancelUserEditing(){
      this.EditingUser = false
    },
    EditUser() {
      this.EditingUser = true
    },

  
       onprofilephotoUpload() {
        var storageRef = firebase.storage().ref('User/' + 'profilephoto/'+this.selectedprofilephotoFile.Name);
        var uploadTask = storageRef.put(this.selectedprofilephotoFile);
        uploadTask
        .then(snapshot => snapshot.ref.getDownloadURL())
          .then((url) => {
            db.collection('users').doc(this.UserRecord.id).update({
                    profilephoto: url
            })
            this.selectedprofilephotoFile = ''
                }),
                  this.profilephotofilesnackbar = true



      },
      onprofilephotoFileselected(event) {
        this.selectedprofilephotoFile = event.target.files[0]
        this.profilephotolocalURL = URL.createObjectURL(this.selectedprofilephotoFile)
      },




      GetBusinessUnitsBusinessUnit() {
      db.collection('businessunits').onSnapshot(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.BusinessUnitArray.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }


      })
    })
      },

      GetUsersManager() {
      db.collection('users').onSnapshot(res => {

      const changes = res.docChanges();
      changes.forEach(change => {
        if (change.type === 'added') {
          this.ManagerArray.push({
            ...change.doc.data(),
            id: change.doc.id
          })
        }


      })
    })
      },
            closeSecurityRoleDialog(){
              this.SecurityRoledialog = false
              setTimeout(() => {
              this.editedRole = Object.assign({}, this.defaultRole)
              this.SecurityRoleIndex = -1
              }, 300)

            },

          ActivateSecurityRoleEditdialog(role){
            this.SecurityRoleIndex = this.SecurityRoles.indexOf(role)
            this.editedRole = Object.assign({}, role)
            //this.BuildsforRoles()
            this.SecurityRoledialog = true
          },

          AssignRoles(){
            const EditedUser = {
              assignedroles: this.AssignedRoles
            }
            let RolesObject = {}
            this.RolesArray= []
            this.AssignedRoles.map(role => {
              RolesObject[role.DisplayName.split(' ').join('')] = true
              this.RolesArray.push(role.DisplayName)
            })
            db.collection('users').doc(this.UserRecord.id).update({
            rolesarrayDBRules: RolesObject,
            rolesarrayQuery: this.RolesArray,
            assignedroles: EditedUser.assignedroles,
            })
          },

          BuildsforRoles(){
         this.Buildsbysystem.map(build => {
            let rolebybuild = this.editedRole.Builds.find(obj => obj.id == build.id)
            if(typeof rolebybuild === 'undefined'){
              let rolebuild = {tempname: build.tempname, id: build.id, getBoolean: false, listBoolean: false, createBoolean: false, updateBoolean: false, deleteBoolean: false}
              this.editedRole.Builds.push(rolebuild)
            }
          })
      },
      
    async GetRequestingUser(){
        var vm = this;
      await firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
          user.getIdTokenResult().then(IdTokenResult => {
              console.log('UsersWantsEmailsOnAllNotifications')
              console.log(IdTokenResult.claims.UsersWantsEmailsOnAllNotifications)
              vm.UsersWantsEmailsOnAllNotifications = IdTokenResult.claims.UsersWantsEmailsOnAllNotifications
            })
            db.collection('users').doc(user.uid).onSnapshot(snapshot => {
              var userdetails = snapshot.data()

              vm.UserRecord = userdetails
              vm.UserRecord.id = user.uid
              if(vm.UserRecord !== 'undefined'){
                vm.GetUser(vm.UserRecord)
                
              }
              
              
              
              
              
            })
           
          }
      else {
        vm.RoutetoLoginPage()
          }
          })
      },
      RoutetoLoginPage(){
        this.$router.push('/login')
      },
      RoutetoErrorPage(){
        this.$router.push('/PermissionError')
      },
      
      
      
      
        GetUser(user) {
          let vm = this
          if(typeof user !== 'undefined'){
            db.collection('users').doc(user.id).onSnapshot(snapshot => {
            var user = snapshot.data()
                  let ActivitiesCollectionReference = db.collection('activities')
                  let ActivitiesstandardQuery = ActivitiesCollectionReference.where('regardingtype', '==', 'User').where('regardingrecord.id', '==', vm.UserRecord.id)
                  let ActivityRegardingQuery =  ActivitiesstandardQuery;
                  vm.GetActivities(ActivityRegardingQuery)
            this.UserData = user
              if(typeof user.Subordinatearrayquery === 'undefined' || user.Subordinatearrayquery.length === 0){
                        let tempSubordindatesArray = []
                        tempSubordindatesArray.push(this.UserRecord.id)
                        let tempSubordinateArrayDBrules = {}
                        tempSubordinateArrayDBrules[this.UserRecord.id] = true
                        db.collection('users').doc(this.UserRecord.id).update({
                        SubordinateArrayDBrules: tempSubordinateArrayDBrules,
                        Subordinatearrayquery: tempSubordindatesArray
                          })
                      }
              else if(typeof user.SubordindatesArray !== 'undefined'){
                this.SubordindatesArray = user.SubordindatesArray
              }
              if(typeof user.IsTeamActivityManager !== 'undefined'){
                this.IsTeamActivityManager = user.IsTeamActivityManager
              }
              if(typeof user.assignedroles !== 'undefined'){
                this.AssignedRoles = user.assignedroles
              }
              if(typeof user.Full_Name !== 'undefined'){
                this.FullName = user.Full_Name
              }
              if(typeof user.Name !== 'undefined'){
                this.Name = user.Name
              }
              if(typeof user.Surname !== 'undefined'){
                this.Surname = user.Surname
              }
              if(typeof user.Manager !== 'undefined'){
                this.Manager = this.ManagerArray.find(Manager => Manager.id === user.Managerid)
              }
              if(typeof user.profilephoto !== 'undefined'){
                this.ProfilePhoto = user.profilephoto
              }
            if(typeof user.notesarray !== 'undefined'){
            this.NotesArray = user.notesarray
              }
            if(typeof user.Owner !== 'undefined'){
              this.BusinessUnit = user.Business_Unit
            }
            this.FullName = user.Full_Name
            this.editedItem.Full_Name = user.Full_Name
            })
          }
        },
        
      
      
    
  

  
    

      ViewActivityItem (item) {
        this.$router.push('/Activity/'+item.id)
      },

      ViewMapItem(PhysicalAddressStreetNumber,PhysicalAddressStreetName,PhysicalAddressSuburb,PhysicalAddressCity,PhysicalAddressPostalCode,PhysicalAddressStateProvince,PhysicalAddressCountryRegion) {
        let combinedlink = PhysicalAddressStreetNumber+'+'+PhysicalAddressStreetName+'+'+PhysicalAddressSuburb+'+'+PhysicalAddressCity+'+'+PhysicalAddressPostalCode+'+'+PhysicalAddressStateProvince+'+'+PhysicalAddressCountryRegion
        let FinalLink = 'https://maps.google.com/?q='+combinedlink.split(' ').join('+')
        window.open(FinalLink, '_blank')
      },

      deleteItem (item) {
        const index = this.UsersArray.indexOf(item)
        confirm('Are you sure you want to delete this item?') && db.collection('users').doc(item.id).delete() && this.UsersArray.splice(index, 1)
      },

      editItem (item) {
        this.editedIndex = this.UsersArray.indexOf(item)
        this.editedItem = Object.assign({}, item)
        
        this.dialog = true
      },
      close () {
        this.dialog = false
        this.UndefinedMandatoryFields.map(prop => {
        
            let element = document.getElementById(prop)
              if(element){  
                var x = element.hasAttribute("class")
                if(x){        
                  element.removeAttribute("class")
                  }
                }
              
            })
      },
        UpdateUserTaskManager(){
          if(typeof this.IsTeamActivityManager !== 'undefined'){
            db.collection('users').doc(this.UserRecord.id).update({
              IsTeamActivityManager: this.IsTeamActivityManager
            })
          }
        },
      UpdateNotifiationEmailer(){
        const UserDefinedMailedNotifications = firebase.functions().httpsCallable('UserDefinedMailedNotifications')
        UserDefinedMailedNotifications({id: this.UserRecord.id, boolean: this.UsersWantsEmailsOnAllNotifications}).then(result => {
          console.log(result);
        })
      },
        

      UpdateUser(){
        this.UndefinedMandatoryFields = []
      const EditedUser = {
    
        }
      for(var prop in EditedUser) {
          if (EditedUser.hasOwnProperty(prop)) {
            if(typeof EditedUser[prop] === 'undefined'){
              this.UndefinedMandatoryFields.push(prop)
            }
          else {
            let element = document.getElementById(prop)
              if(element){  
                var x = element.hasAttribute("class")
                if(x){        
                  element.removeAttribute("class")
                  }
                }
            }
            }
      
          else{
            console.log('something is amook')
          }
        }
        console.log(this.UndefinedMandatoryFields)
      
      
      //this below database "update" is applicable to the update of mandatory fields
      if(this.UndefinedMandatoryFields.length === 0){
      db.collection('users').doc(this.UserRecord.id).update({
              });
              this.close()
              this.EditedUsersnackbar = true
              this.CancelUserEditing()
              //exactly what we did here, what we incorrectly did here with lookupfields, we will do with optional fields. So this shoudl change to a v-for on optional fields, and same logic, if undefined on each, then nothing otherwise update record with said field
              
                     if(typeof this.IsTeamActivityManager !== 'undefined'){
                       db.collection('users').doc(this.UserRecord.id).update({
                         IsTeamActivityManager: this.IsTeamActivityManager
                       })
                     }
                      if(typeof this.AssignedRoles !== 'undefined'){
                        db.collection('users').doc(this.UserRecord.id).update({
                         assignedroles: this.AssignedRoles
                       })
                      }
                      if(typeof this.FullName !== 'undefined'){
                        db.collection('users').doc(this.UserRecord.id).update({
                         Full_Name: this.FullName
                       })
                      }
                      if(typeof this.Name !== 'undefined'){
                        db.collection('users').doc(this.UserRecord.id).update({
                         Name: this.Name
                       })
                      }
                      if(typeof this.Surname !== 'undefined'){
                        db.collection('users').doc(this.UserRecord.id).update({
                         Surname: this.Surname
                       })
                      }
                      
                      if(typeof this.Manager !== 'undefined'){
                        db.collection('users').doc(this.UserRecord.id).update({
                         Manager: {Full_Name: this.Manager.Name+' '+this.Manager.Surname,Name: this.Manager.Name, Surname: this.Manager.Surname, id: this.Manager.id},
                         Managerid: this.Manager.id
                       })
                      }
      }
      else{
        alert('you need to capture the values in '+this.UndefinedMandatoryFields)
        this.UndefinedMandatoryFields.map(field => {
          console.log('getting element by id '+field)
          let element = document.getElementById(field)
          
          element.setAttribute("class", "incompletedmandatory")
          console.log('here is element')
          console.log(element)
        })
      }
      },

  }
}


</script>

<style>
/* .borderthicknobottom{
  border-top: 3px solid #35353b;
  border-left: 3px solid #35353b;
  border-right: 3px solid #35353b;
}
.borderthicknotop{
  border-bottom: 3px solid #35353b;
  border-left: 3px solid #35353b;
  border-right: 3px solid #35353b;
} */
.moving-clouds {
    position: absolute;
    z-index: 1;
    bottom: 0;
    left: 0;
    width: 250.625em;
    height: 43.75em;
    animation: c 80s linear infinite;
}
@keyframes c {
  0% {
    transform: translateZ(0);
  }
  100% {
        transform: translate3d(-50%,0,0);
  }
  
}
.outline {
  margin: 30px;
  background: #f8f8f8;
  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
  outline-offset: 15px;
}
.notesoutline{


  background-color: yellow;
  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
.basicoutlined{
  background: #f8f8f8;
  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
.newbasicoutlined{

  border: 1px solid #dedee9;
  outline: 1px solid #dedee9;
}
.notestitle{
  background-color: rgb(218, 218, 84);

}
.outlinefont{
  color: red
}
.fab-container {
  position: fixed;
  bottom: 60px;
  right: 50px;
  z-index: 100
}
.unpermitted .tooltiptext {
  visibility: hidden;
  width: 250px;
  background-color: rgb(0, 153, 255);
  color: white;
  text-align: center;
  border-radius: 6px;
  font-size: 15px;
  padding: 15px 0;

  /* Position the tooltip */
  position: absolute;
  z-index: 100;
}

.unpermitted:hover .tooltiptext {
  visibility: visible;
}

.banner {
  z-index: 200;
}
.taskdetails{
  font-size: 12px
}
.subheading{
  font-size: 12px
}
.notes{
  font-size: 12px
}
</style>
          
            
        


    